module.exports = __webpack_public_path__ + "src/assets/img/abbinder_en.a8a4372f.svg";